import { render } from "./Select.vue?vue&type=template&id=fda0c7d8&scoped=true"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"

import "./Select.vue?vue&type=style&index=0&id=fda0c7d8&lang=scss&scoped=true"
import "./Select.vue?vue&type=style&index=1&id=fda0c7d8&lang=scss&global=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fda0c7d8"]])

export default __exports__